import { useMemo } from 'react';
import { Box, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from "../../../../i18n";
import styles from "./VariableFieldAdornment.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetVariableFieldAdornmentTID = parentTestId => getTestIds(parentTestId);
export function VariableFieldAdornment(_ref) {
  let {
    onClick,
    disabled,
    testId
  } = _ref;
  const {
    VariableFieldAdornmentTestIds
  } = useMemo(() => GetVariableFieldAdornmentTID(testId), [testId]);
  const {
    t
  } = useLocaleKeys('components.templateVariables');
  if (disabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    as: "button",
    className: styles.adornmentButton,
    onClick: onClick,
    "aria-label": t.insertButton(),
    "aria-haspopup": "dialog",
    testId: VariableFieldAdornmentTestIds.Root(),
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      weight: "bold",
      skin: "secondary",
      children: '{ }'
    })
  });
}